import { RootState } from '@modules/App/redux/store';
import { AsyncData } from '@shared/interfaces/asyncData';
import { MyTeamEvalData } from '@modules/EvaluationModule/interfaces/MyTeamEvalData';

export const selectMyPeopleEvalData = (state: RootState): AsyncData<MyTeamEvalData[]> =>
  state.evaluation.myPeopleEvalPage.myPeopleEvalData;
